import { dia, util } from '@joint/plus';

const PRIMARY_SHAPE_COLOR = '#353535';
const CONTROL_GROUP_COLOR = 'orange';
const INPUT_GROUP_COLOR = 'red';
const OUTPUT_GROUP_COLOR = 'green';

export const stencilGroups = {
  inputs: { index: 1, label: 'Entrées' },
  controls: { index: 2, label: 'Contrôles' },
  exchangers: { index: 3, label: 'Échangeurs' },
  outputs: { index: 4, label: 'Sorties' },
  stocks: { index: 5, label: 'Stocks' },
  variables: { index: 6, label: 'Variables' },
};

function calculateTextSize(text, fontSize, fontFamily) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = `${fontSize}px ${fontFamily}`;
  const metrics = context.measureText(text);
  return {
    width: metrics.width + 10,
    height: fontSize + 6,
  };
}

export const StencilBackground = dia.HighlighterView.extend({
  tagName: 'rect',
  attributes: {
    stroke: 'none',
    fill: 'transparent',
    'pointer-events': 'none',
    rx: 4,
    ry: 4,
  },
  style: {
    transition: 'fill 400ms',
  },
  options: {
    padding: 0,
    color: 'gray',
    width: null,
    height: null,
    layer: dia.Paper.Layers.BACK,
  },
  highlight(cellView, _node) {
    const { padding, width, height } = this.options;
    const bbox = cellView.model.getBBox();
    bbox.x = bbox.y = 0;
    if (Number.isFinite(width)) {
      bbox.x = (bbox.width - width) / 2;
      bbox.width = width;
    }
    if (Number.isFinite(height)) {
      bbox.y = (bbox.height - height) / 2;
      bbox.height = height;
    }
    bbox.inflate(padding);
    this.vel.attr(bbox.toJSON());
    util.nextFrame(() => this.vel.attr('fill', this.options.color));
  },
});

export const getStencilShapes = (isDarkThemeUsed) => ({
  inputs: [
    {
      type: 'standard.Rectangle',
      name: 'BE',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: INPUT_GROUP_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'BE',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'CheckIn_',
      },
      size: calculateTextSize('BE', 4, 'Roboto'),
    },
    {
      type: 'standard.Rectangle',
      name: 'DC',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: INPUT_GROUP_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'DC',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'DropOff_',
      },
      size: calculateTextSize('DC', 4, 'Roboto'),
    },
  ],
  controls: [
    {
      type: 'standard.Rectangle',
      name: 'PIM',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: CONTROL_GROUP_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'PIM',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'ManualIdentificationPoint_',
      },
      size: calculateTextSize('PIM', 4, 'Roboto'),
    },
    {
      type: 'standard.Rectangle',
      name: 'CP',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: CONTROL_GROUP_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'CP',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'PrimaryControl_',
      },
      size: calculateTextSize('CP', 4, 'Roboto'),
    },
    {
      type: 'standard.Rectangle',
      name: 'CC',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: CONTROL_GROUP_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'CC',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'ComplementaryControl_',
      },
      size: calculateTextSize('CC', 4, 'Roboto'),
    },
    {
      type: 'standard.Rectangle',
      name: 'CU',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: CONTROL_GROUP_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'CU',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'LastControl_',
      },
      size: calculateTextSize('CU', 4, 'Roboto'),
    },
  ],
  exchangers: [
    {
      type: 'standard.Rectangle',
      name: 'MEB',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: PRIMARY_SHAPE_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'MEB',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'LoadingStation_',
      },
      size: calculateTextSize('MEB', 4, 'Roboto'),
    },
    {
      type: 'standard.Rectangle',
      name: 'DEB',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: PRIMARY_SHAPE_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'DEB',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'UnloadingStation_',
      },
      maxDestinations: Infinity,
      size: calculateTextSize('DEB', 4, 'Roboto'),
    },
    {
      type: 'standard.Rectangle',
      name: 'ECH',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: PRIMARY_SHAPE_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'ECH',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'TechnologyExchanger_',
      },
      maxDestinations: Infinity,
      size: calculateTextSize('ECH', 4, 'Roboto'),
    },
  ],
  outputs: [
    {
      type: 'standard.Rectangle',
      name: 'PFT',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: OUTPUT_GROUP_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'PFT',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'FinalSortingPoint_',
      },
      size: calculateTextSize('PFT', 4, 'Roboto'),
    },
    {
      type: 'standard.Rectangle',
      name: 'DM',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: OUTPUT_GROUP_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'DM',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'LastMinuteSortingPoint_',
      },
      size: calculateTextSize('DM', 4, 'Roboto'),
    },
    {
      type: 'standard.Rectangle',
      name: 'REBUT',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: OUTPUT_GROUP_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'REBUT',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'RejectionPoint_',
      },
      size: calculateTextSize('REBUT', 4, 'Roboto'),
    },
  ],
  stocks: [
    {
      type: 'appShapes.Stock',
      name: 'Stock',
      attrs: {
        body: {
          fill: '#ffffff',
          stroke: '#bebebe',
          strokeWidth: 2,
          rx: 40,
          ry: 40,
        },
        label: {
          text: 'STOCK',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'Stock_',
      },
      size: calculateTextSize('STOCK', 4, 'Roboto'),
    },
  ],
  variables: [
    {
      type: 'standard.Rectangle',
      name: 'CONV',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: PRIMARY_SHAPE_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'CONV',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'Convergence_',
      },
      size: calculateTextSize('CONV', 4, 'Roboto'),
    },
    {
      type: 'appShapes.Div',
      name: 'DIV',
      attrs: {
        body: {
          fill: '#FFFFFF',
          stroke: PRIMARY_SHAPE_COLOR,
          strokeWidth: 1,
        },
        label: {
          text: 'DIV',
          fill: PRIMARY_SHAPE_COLOR,
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'Divergence_',
      },
      size: calculateTextSize('DIV', 4, 'Roboto'),
    },
    {
      type: 'appShapes.Tri',
      name: 'TRI',
      attrs: {
        body: {
          fill: 'transparent',
          stroke: '#bebebe',
          strokeWidth: 2,
          rx: 40,
          ry: 40,
        },
        label: {
          text: 'TRI',
          fill: isDarkThemeUsed ? '#ffffff' : '#2a2a2a',
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 'Bold',
          fontSize: 10,
        },
        chevron1: {
          fill: 'none',
          stroke: isDarkThemeUsed ? '#ffffff' : '#2a2a2a',
          strokeWidth: 3,
        },
        chevron2: {
          fill: 'none',
          stroke: isDarkThemeUsed ? '#ffffff' : '#2a2a2a',
          strokeWidth: 3,
        },
      },
      customAttributes: {
        type: 'default',
        additionalInfo: null,
        fullName: 'Tri_',
      },
      size: calculateTextSize('TRI', 4, 'Roboto'),
      ports: {
        items: [
          { id: 'port1', group: 'auto', time: 0 },
          { id: 'port2', group: 'auto', time: 0 },
          { id: 'port3', group: 'auto', time: 0 },
          { id: 'port4', group: 'auto', time: 0 },
        ],
      },
    },
  ],
});
